/** The Underwriting queue kicker.
 *
 *  It used to read `${filtered} of ${returned}` where both counts came from a
 *  server list capped at 20, so a 37-assignment desk said "20 of 20 shown" and
 *  hid 17 deals (stress test EXEC-11). The denominator is now the server's
 *  total, and a list the server capped says so. */
export function queueKicker(shown: number, returned: number, total: number | null | undefined): string {
  const whole = total ?? returned
  const base = `${shown.toLocaleString('en-US')} of ${whole.toLocaleString('en-US')} shown`
  if (whole > returned) {
    return `${base} · first ${returned.toLocaleString('en-US')} loaded — the Active assignments tile opens all ${whole.toLocaleString('en-US')}`
  }
  return base
}

/** One option in the queue picker (T-54).
 *
 *  The server lists every queue with work, then every other staff member at 0
 *  (Jeff and Louis were missing on the 2 Nov run-through because the picker held
 *  only owners of live work). `name` is the person's label — an email-keyed
 *  queue arrives under its account's name — and is absent on a board built
 *  before it shipped, so the queue key still reads. Null on both is the
 *  Unassigned queue. */
export function rosterOptionLabel(row: { name?: string | null; analystEmail: string | null; active: number }): string {
  return `${row.name ?? row.analystEmail ?? 'Unassigned'} (${row.active})`
}
